export const ACTIVE: { [key: string]: string } = {
  active: 'Aktiv',
  inactive: 'Inaktiv',
}

export const ACTIVE_ENTRIES = Object.entries(ACTIVE).map(([k, v]) => ({ id: k, name: v }))
